<template>
  <div
    v-tooltip="{
      /* d99d */ content: parsedLastMessage,
      delay: { show: 1200, hide: 0 },
      placement: `bottom-${rtl ? 'end' : 'start'}`,
    }"
    class="overflow-hidden text-ellipsis whitespace-nowrap w-full"
    @click="$emit('click')"
  >
    <div class="flex gap-2 items-center flex-row justify-between">
      <div class="text-ellipsis overflow-hidden">
        <span v-if="message.content" v-dompurify-html="parsedLastMessage" />
        <span v-else-if="message.attachments">
          <fluent-icon
            v-if="attachmentIcon && showMessageType"
            size="16"
            class="-mt-0.5 align-middle inline-block text-slate-600 dark:text-slate-300"
            :icon="attachmentIcon"
          />
          {{ $t(`${attachmentMessageContent}`) }}
        </span>
        <span v-else>
          {{ defaultEmptyMessage || $t('CHAT_LIST.NO_CONTENT') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGE_TYPE } from 'widget/helpers/constants';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import { ATTACHMENT_ICONS } from 'shared/constants/messages';
import localeMixin from 'shared/mixins/localeMixin';
import alertMixin from '../../../../shared/mixins/alertMixin';

export default {
  name: 'EmailMessagePreview',
  mixins: [messageFormatterMixin, localeMixin, alertMixin /* d99d */],
  props: {
    message: {
      type: Object,
      required: true,
    },
    showMessageType: {
      type: Boolean,
      default: true,
    },
    defaultEmptyMessage: {
      type: String,
      default: '',
    },
    additionalAttributes: {
      type: Object,
      default: () => {},
    },
    showSubject: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    subject() {
      const { content_attributes: contentAttributes } = this.message;
      const { email: { subject } = {} } = contentAttributes || {};

      return this.additionalAttributes?.mail_subject || subject;
    },
    parsedLastMessage() {
      if (this.emailMessageContent) {
        return this.emailMessageContent
          .replace(/<\/?[^>]+>/gi, ' ')
          .trim()
          .slice(0, 150);
      }
      return this.formatMessage(
        this.showSubject
          ? this.subject || this.message.content
          : this.message.content,
        false,
        true,
        true
      )
        .replace(/<\/?[^>]+>/gi, ' ')
        .trim()
        .slice(0, 150);
    },
    emailMessageContent() {
      const { content_attributes: contentAttributes } = this.message;
      const {
        html_content: { quoted: quotedHTMLContent } = {},
        text_content: { quoted: quotedTextContent } = {},
      } = contentAttributes.email || {};
      return quotedHTMLContent || quotedTextContent || '';
    },
    lastMessageFileType() {
      const [{ file_type: fileType } = {}] = this.message.attachments;
      return fileType;
    },
    attachmentIcon() {
      return ATTACHMENT_ICONS[this.lastMessageFileType];
    },
    attachmentMessageContent() {
      return `CHAT_LIST.ATTACHMENTS.${this.lastMessageFileType}.CONTENT`;
    },
  },
};
</script>
